/**
 * Created by xnr on 20/2/24.
 */

import * as admincustomer from "./admincustomer";

import * as admincustomerq from "./admincustomerq";
import * as system from "./system";
import * as role from "./role";
import * as config from "./config";
import * as dict from "./dict";
import * as activitymsg from "./activitymsg";
import * as paradise from "./paradise";
import * as goods from "./goods";
import * as banner from "./banner";
import * as store from "./store";
import * as rem from "./rem";
import * as order from "./order";
import * as afterSale from "./afterSale";
import * as message from "./message";
import * as customerService from "./customerService";
import * as askQuestions from "./askQuestions";
import * as agreement from "./agreement";
import * as fund from "./fund";
import * as city from "./city";
import * as stock from "./stock";
import * as inorder from "./inorder";
import * as outorder from "./outorder";
import * as backstop from "./backstop";
import * as aliSms from "./aliSms";
import * as client from "./client";
import * as shebei from "./shebei";
import * as enterpriseincome from "./enterpriseincome";
import * as indexZ from "./indexZ";
import * as communication from "./communication";
import * as camera from "./camera";
import * as sim from "./sim";
import * as waterCard from "./waterCard";
import * as afterPeople from "./afterPeople";
import * as marketing from "./marketing";
import * as home from "./home";
import * as zone from "./zone";
import * as staff from "./staff";
import * as partner from "./partner";
import * as staffClient from "./staffClient";
import * as sellTeam from "./sellTeam";
import * as valueAddedService from "./valueAddedService";
import * as teamPerformance from "./teamPerformance";
import * as dataAnalysis from "./dataAnalysis";

const apiObj = {
  enterpriseincome,
  shebei,
  client,
  aliSms,
  backstop,
  outorder,
  inorder,
  stock,
  city,
  fund,
  agreement,
  askQuestions,
  customerService,
  message,
  afterSale,
  admincustomer,
  admincustomerq,
  system,
  role,
  config,
  dict,
  paradise,
  goods,
  activitymsg,
  banner,
  store,
  rem,
  order,
  indexZ,
  communication,
  camera,
  sim,
  waterCard,
  afterPeople,
  marketing,
  home,
  zone,
  staff,
  partner,
  staffClient,
  sellTeam,
  valueAddedService,
  teamPerformance,
  dataAnalysis
};

const install = function(Vue) {
  if (install.installed) return;
  install.installed = true;
  Object.defineProperties(Vue.prototype, {
    $api: {
      get() {
        return apiObj;
      },
    },
  });
};
export default {
  install,
};
